export const environment = {
    production: false,
    apiUrl: 'https://playgolf.dankospark.co.za/api/'
}
